import type { FC, PropsWithChildren } from 'react';

import { useTranslation } from 'react-i18next';
import { Links, Meta, Scripts, ScrollRestoration, useNavigation } from 'react-router';

import { ProgressBar } from '@/components/common/ProgressBar';

export const RootLayout: FC<PropsWithChildren> = ({ children }) => {
  const navigation = useNavigation();
  const { i18n } = useTranslation();
  return (
    <html lang={i18n.language} className="light bg-secondary">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body className="bg-secondary">
        {navigation.state !== 'idle' && (
          <ProgressBar className="fixed top-0 left-0 z-9999 h-1 w-full" />
        )}
        <main className="flex min-h-screen flex-col bg-white">{children}</main>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
};
